(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fr-preorder-offer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fr-preorder-offer')) {
    customElements.define('fr-preorder-offer', class extends HTMLElement {
      connectedCallback() {
        this.checkExpiry = () => {
          clearTimeout(this.expiryTimer);
          const remaining = Number(this.dataset.endsAt) * 1000 - Date.now();
          if (!Number.isFinite(remaining) || remaining <= 0) {
            const fallback = this.querySelector('template[data-offer-expired]');
            if (fallback) this.replaceChildren(fallback.content.cloneNode(true));
            this.removeAttribute('data-ends-at');
            return;
          }
          this.expiryTimer = setTimeout(this.checkExpiry, Math.min(remaining, 60000));
        };
        this.checkExpiry();
        document.addEventListener('visibilitychange', this.checkExpiry);
      }
      disconnectedCallback() {
        clearTimeout(this.expiryTimer);
        document.removeEventListener('visibilitychange', this.checkExpiry);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-dropdown-menu"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fr-menu-ride-toggle')) {
    customElements.define('fr-menu-ride-toggle', class extends HTMLElement {
      connectedCallback() {
        this.onChoice = (event) => {
          const button = event.target.closest('button[data-menu-ride]');
          if (!button || !this.contains(button)) return;
          const mode = button.dataset.menuRide;
          this.querySelectorAll('button[data-menu-ride]').forEach((choice) => {
            choice.setAttribute('aria-pressed', String(choice === button));
          });
          this.closest('[data-fr-model-navigation]').querySelectorAll('[data-nav-ride-card]').forEach((card) => {
            card.hidden = card.dataset.navRideCard !== mode;
          });
        };
        this.addEventListener('click', this.onChoice);
      }
      disconnectedCallback() { this.removeEventListener('click', this.onChoice); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
